import { Component, OnInit } from '@angular/core';
import { ClientUser } from '../../../../core/store/admin/users/users.interface';
import { ClientUserEditContainer } from './client-user-edit.container';
import { ClientUserInviteAction } from '../../../../core/store/admin/users/users.actions';
import { fadeInAnimation } from '../../../../animations';

@Component({
  selector: 'admin-customer-client-invite',
  templateUrl: './client-user-edit.container.html',
  styleUrls: ['./client-user-edit.container.scss'],
  animations: [fadeInAnimation],
})
export class ClientUserInviteContainer extends ClientUserEditContainer implements OnInit {

  inviteUser(epsUser: ClientUser) {
    this.store.dispatch(new ClientUserInviteAction(epsUser));
  }
}
